import { inject, Injectable } from '@angular/core';
import { WINDOW } from '@innogy/utils-dom';
import { SentryErrorHandler } from '@sentry/angular';
import defaultTo from 'lodash/defaultTo';
import { CookieService } from 'ngx-cookie-service';

@Injectable({ providedIn: 'root' })
export class CustomErrorHandler extends SentryErrorHandler {
  readonly #windowRef = inject(WINDOW);
  readonly #cookies = inject(CookieService);

  constructor() {
    super();
  }

  override handleError(error: any): void {
    // Reload window when a chunk fails to load:
    if (error instanceof Error && error.name === 'ChunkLoadError') {
      const reloadsValue = this.#cookies.get('chunkLoadErrorReloads');
      let reloads = defaultTo(parseInt(reloadsValue), 0);
      if (reloads <= 2) {
        reloads += 1;
        this.#cookies.set('chunkLoadErrorReloads', `${reloads}`);
        this.#windowRef.location.reload();
      }
    }

    // Call Sentry's error handler to capture errors:
    super.handleError(error);
  }
}
